const mContentEditorModalAllowedUrl = {
  mContentEditorModalAllowedUrl: {
    amazon: {
      title: 'Amazon',
      description: 'Puede variar dependiendo de la configuración de Amazon',
      list: {
        url1: 'https://{nombre-del-bucket}.s3-{region}.amazonaws.com/{nombre-del-archivo-de-video}'
      }
    },

    bunny: {
      title: 'Bunny.net',
      description: '',
      list: {
        url1: 'https://iframe.mediadelivery.net/embed/{id-de-carpeta}/{id-del-video}',
        url2: 'https://video.bunnycdn.com/play/{id-de-carpeta}/{id-del-video}',
        url3: 'Embed code'
      }
    },

    title: 'Urls de video permitidas',

    vimeo: {
      title: 'Vimeo',
      description: '',
      list: {
        url1: 'https://vimeo.com/{id-del-video}',
        url2: 'https://vimeo.com/{id-del-video}?share=copy',
        url3: 'https://player.vimeo.com/video/{id-del-video}',
        url4: 'https://player.vimeo.com/video/{id-del-video}?h={codigo-de-reproducción}',
        url5: 'https://vimeo.com/{id-de-carpeta}/{id-del-video}',
        url6: 'https://vimeo.com/{id-de-carpeta}/{id-del-video}?share=copy',
        url7: 'https://player.vimeo.com/video/{id-de-carpeta}?h={id-del-video}',
        url8: 'https://player.vimeo.com/video/{id-de-carpeta}?h={id-del-video}&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
      }
    },

    youtube: {
      title: 'Youtube',
      description: '',
      list: {
        url1: 'http://www.youtube.com/watch?v={id-del-video}',
        url2: 'http://youtu.be/{id-del-video}',
        url3: 'https://youtube.googleapis.com/v/{id-del-video}'
      }
    }
  }
}

export default mContentEditorModalAllowedUrl
